export default "<div id=\"dmi-form-body\"></div>";